module.exports = __webpack_public_path__ + "static/media/noclass2.1e19b51d.png";